module.exports = __webpack_public_path__ + "static/media/image_38.43a63d2d.png";